import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as d3 from 'd3';
import styles from './ZillowCaption.css';
import withStyles from '../../decorators/withStyles';
import { getScenarioDescription } from "../../utils/utils";


class ZillowCaption extends Component {

  static propTypes = {
    elevMeta: PropTypes.object.isRequired,
    zillowEndYr: PropTypes.string.isRequired,
    zillowModel: PropTypes.string.isRequired,
    zillowPathway: PropTypes.string.isRequired,
    zillowProb: PropTypes.string.isRequired,
    zillowVarType: PropTypes.string.isRequired,
  };

  setTxContent = (el) => {
    d3.select(el).attr('tx-content', 'block');
  };

  getHousingFootnote = () => {
    const { zillowEndYr, zillowVarType } = this.props;
    if (zillowVarType === 'Growth' && zillowEndYr !== '2005') {
      return <p>Housing construction rates measure construction between <var>2010-{zillowEndYr}</var> relative to construction prior to 2010. The analysis only includes homes for which the year built is known.</p>;
    } else {
      return <p>*Housing data are for years up to and including <var>{zillowEndYr}</var>.</p>;
    }
  }

  render() {
    const { elevMeta, zillowModel, zillowPathway, zillowProb } = this.props;
    const scenarioDescr = getScenarioDescription(zillowModel, zillowPathway, zillowProb);

    const sources = (
      <p ref={this.setTxContent}>Sources: Elevation data, <var><a href={elevMeta.url} target="_blank">{elevMeta.name}</a></var>;
        administrative boundaries, <var><a href="http://www.census.gov/geo/maps-data/data/tiger-line.html#tab_2012" target="_blank">US Census</a></var>. <a href="https://www.zillow.com/zestimate/" target="_blank">Zestimate<sup>&reg;</sup></a> data provided by Zillow; address and build year data were provided by Zillow through the Zillow Transaction and Assessment Dataset (<a href="https://www.zillow.com/ztrax/" target="_blank">ZTRAX</a>).
      </p>
    );

    const relatedLinks = (
      <p className="related-links">
        <span>See: </span>
        <span><a href="https://www.climatecentral.org/news/ocean-at-the-door-new-homes-in-harms-way-zillow-analysis-21953" target="_blank">original report</a></span>
        <span> | </span>
        <span><a href="https://rzh.climatecentral.org/" target="_blank">national interactive</a></span>
        <span> | </span>
        <span><a href="https://www.zillow.com/research/?p=21931&preview=true" target="_blank">research brief</a></span>
      </p>
    );

    return (
      <div className="ZillowCaption">
        <div className="map-explain">
          {this.getHousingFootnote()}
          <p>{scenarioDescr}</p>
          {sources}
        </div>
        {relatedLinks}
      </div>
    );
  }

}

export default withStyles(styles)(ZillowCaption);
